import React from 'react'
import WestfieldLogo from './westfield-logo.inline.svg?react'
import WestfieldLogoRed from './westfield-logo-red.inline.svg?react'
import cx from 'classnames'
import style from './index.module.scss'

export type LogoType =
  | 'default'
  | 'alt'
  | 'direct-digital'
  | 'direct-digital-mono'
  | 'direct-marketing'
  | 'direct-marketing-mono'
  | 'westfield-plus'
  | 'westfield-red'

interface LogoWithoutLinkProps {
  className?: string
  type?: LogoType

  [key: string]: unknown //...props
}

const LogoWithoutLink: React.FunctionComponent<LogoWithoutLinkProps> = ({
  className,
  type = 'default',
  ...props
}) => {
  switch (type) {
    case 'westfield-red':
      return (
        <WestfieldLogoRed {...props} className={cx(className, style[type])} />
      )
    default:
      return <WestfieldLogo {...props} className={cx(className, style[type])} />
  }
}

export default LogoWithoutLink
